export const Style = ({ colors = [] }) => (
  <g id="Estilo3_2_">
    <path
      id="Multiply_3_"
      style={{
        display: 'inline',
        opacity: '0.49',
        fill: '#FDBFA8',
        enableBackground: 'new'
      }}
      d="M82.8,39.5H69.4 c-7.8,0-14.1,6.2-14.2,14l-0.6,7.6c0,0.9,0.2,2.7,0.5,4.8c2.5-1.2,4.9-2.6,6.6-4.4c0.6-0.7,1.3-1.3,2.1-2.1c2-1.9,3.5-4.3,5.1-6.9 c1.8-2.8,3.7-5.8,6.3-8.6c1.8-1.3,3.8-2,6.4-2c0.9,0,1.9,0.1,3,0.3c0.8,3.9,3.4,13.5,10,22l1.5,1.9c0.3-2.1,0.6-4.6,0.9-7.5 l-1.4-5.9c-0.8-3.2-2.3-6.1-4.4-8.6C89.5,42,86.8,39.5,82.8,39.5z"
    />

    <linearGradient
      id="SVGID_182_"
      gradientUnits="userSpaceOnUse"
      x1="91.3843"
      y1="-319.03"
      x2="99.6734"
      y2="-319.03"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_182_)' }}
      d="M95.2,71.6c1.6-1.8,5.4-7.6,4.3-21.3l-3.6,3.5l1.1,4.8 C96.5,64.5,95.8,68.6,95.2,71.6z"
    />

    <linearGradient
      id="SVGID_183_"
      gradientUnits="userSpaceOnUse"
      x1="51.8635"
      y1="-314.97"
      x2="59.448"
      y2="-314.97"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_183_)' }}
      d="M55,57.2L52.6,59c-2.6,9.7,2.3,13.1,3.8,13.8c-0.8-4.4-1.6-9.8-1.6-11.8 L55,57.2z"
    />

    <linearGradient
      id="SVGID_184_"
      gradientUnits="userSpaceOnUse"
      x1="79.9139"
      y1="-323.1642"
      x2="90.6428"
      y2="-323.1642"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_184_)' }}
      d="M90.6,60.4c0.2-0.1-6.6-4.3-10.7-4.2c-0.1,0.1,0.1-4.4,5.6-2.4 C90.8,56,90.6,60.4,90.6,60.4z"
    />

    <linearGradient
      id="SVGID_185_"
      gradientUnits="userSpaceOnUse"
      x1="59.9672"
      y1="-323.1642"
      x2="70.6961"
      y2="-323.1642"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_185_)' }}
      d="M60,60.4c-0.2-0.1,6.6-4.3,10.7-4.2c0.1,0.1-0.1-4.4-5.6-2.4 C59.8,56,60,60.4,60,60.4z"
    />

    <linearGradient
      id="SVGID_186_"
      gradientUnits="userSpaceOnUse"
      x1="44.1313"
      y1="-334.5507"
      x2="99.6753"
      y2="-334.5507"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_186_)' }}
      d="M99.7,50.3c-0.1-0.7-0.1-1.3-0.1-2C99,35.1,92.6,34,88.6,34.5 c-0.6-2.1-3.1-9-9.7-10.2c-9.8-1.8-41.1,5.5-33.6,42.4c0,0,10.6-2.6,14.8-7c0.7-0.7,1.4-1.4,2.2-2.2c3.7-3.6,6.1-9.9,11.5-15.5 c2.7-2,6.1-3.1,11.2-2.3c1,0.2,1.9,0.9,2.1,1.9c0.9,3.9,3.7,13.1,9.8,21.1c0,0,0.9-4.1,1.5-6.7c0.3-1.3,0.6-2.5,1-3.7 C99.5,51.7,99.7,50.9,99.7,50.3z"
    />

    <linearGradient
      id="SVGID_187_"
      gradientUnits="userSpaceOnUse"
      x1="69.4915"
      y1="-348.2255"
      x2="89.7771"
      y2="-373.0916"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: '#FFDEC7' }} />
      <stop offset="0.9944" style={{ stopColor: '#7C297F' }} />
    </linearGradient>
    <path
      style={{
        display: 'inline',
        opacity: '0.3',
        fill: 'url(#SVGID_187_)',
        enableBackground: 'new',
        mixBlendMode: 'multiply'
      }}
      d="M68.6,28.5 c11.8-3.8,17.9,1.3,17.9,1.3c-1.5-2.4-3.9-4.8-7.7-5.5c-6.7-1.2-23.4,1.8-31,15.6C48,39.9,58.7,31.7,68.6,28.5z"
    />

    <linearGradient
      id="SVGID_188_"
      gradientUnits="userSpaceOnUse"
      x1="99.5423"
      y1="-348.207"
      x2="80.4018"
      y2="-316.4698"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: '#FFDEC7' }} />
      <stop offset="0.9944" style={{ stopColor: '#7C297F' }} />
    </linearGradient>
    <path
      style={{
        display: 'inline',
        opacity: '0.3',
        fill: 'url(#SVGID_188_)',
        enableBackground: 'new',
        mixBlendMode: 'multiply'
      }}
      d="M99.5,47.2 c-0.8-12.2-7-13.3-10.8-12.7C88.6,34.5,98.4,37.5,99.5,47.2z"
    />
  </g>
)

export const Back = ({ colors = [] }) => (
  <g id="Estilo3_7_">
    <linearGradient
      id="SVGID_55423_"
      gradientUnits="userSpaceOnUse"
      x1="74.4495"
      y1="-280.0687"
      x2="74.4495"
      y2="-318.3768"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_55423_)' }}
      d="M102.1,50.8c-0.8-22.1-16.2-15-16.2-15l-20.1,0c0,0-17.3-7.2-18.3,15.3 s-16.4,39.5,3.5,51c11.2,6.5,20.5,3.9,26.4,0.4c5.3,2.8,12.8,4.2,21.6-1.5C116.6,89.7,103,72.9,102.1,50.8z"
    />
  </g>
)

Style.Back = Back
